import { checkResponse, get, e } from '@/helpers/http.js'


export function getUser () {
  return get(e('/api/v1/session_info'))
    .then(checkResponse)
}